<template>
  <div class="dashboard__navbar">
    <div class="dashboard__navbar-wrap">
      <svgicon
        icon="menu"
        class="sidebar__menu"
        @click="toggleSidebar"
      ></svgicon>
      <p class="dashboard__navbar-title">
        {{
          currentRouteName == "dashboard"
            ? "Overview"
            : currentRouteName == "listing"
            ? "Listings"
            : currentRouteName == "listingDetail"
            ? "Listing"
            : currentRouteName == "member"
            ? "Members"
            : currentRouteName == "memberDetail"
            ? "Members"
            : currentRouteName == "booking"
            ? "Bookings"
            : currentRouteName == "referral"
            ? "Referrals"
            : currentRouteName == "referrerDetail"
            ? "Referrer Details"
            : currentRouteName == "bookingDetail"
            ? "Bookings"
            : currentRouteName == "subscription"
            ? "Subscriptions"
            : currentRouteName == "subscriptionDetail"
            ? "Subscriptions"
            : currentRouteName == "lost"
            ? "We lost you"
            : currentRouteName == "lost-two"
            ? "We lost you"
            : currentRouteName == "invoices"
            ? "Invoices"
            : currentRouteName == "maintenance"
            ? "Maintenance Request"
            : currentRouteName == "settlements"
            ? "Settlements"
            : currentRouteName == "verifyRequests"
            ? "Verify Requests"
            : currentRouteName == "verifyDetails"
            ? "Verification Information"
            : currentRouteName == "teamMembers"
            ? "Team Members"
            : ""
        }}
      </p>

      <b-nav-item-dropdown
        class="listingNavbar__profile-wrap listingNavbar__profile-container"
        right
      >
        <!-- Using 'button-content' slot -->
        <template v-slot:button-content>
          <em class="listingNavbar__profile">
            <span class="listingNavbar__profile-initial">
              {{ adminInitials }}</span
            >
          </em>
        </template>
        <b-dropdown-item-button @click="logout">Logout</b-dropdown-item-button>
      </b-nav-item-dropdown>
    </div>
  </div>
</template>

<script>
import VueCookies from "vue-cookies";
const domain = process.env.VUE_APP_DOMAIN;
export default {
  name: "dashboardNavbar",
  props: {
    mobile: Boolean,
    toggleSidebar: Function
  },
  data() {
    return {
      listingName: ""
    };
  },
  methods: {
    logout() {
      localStorage.clear();
      if (domain == "localhost") {
        VueCookies.remove("admin", "/", `${domain}`);
        this.$router.push("/");
      } else {
        VueCookies.remove("admin", "/", `.${domain}`);
        this.$router.push("/");
      }
    }
  },
  computed: {
    currentRouteName() {
      return this.$route.name;
    },

    adminInitials() {
      const data = VueCookies.get("data");
      const firstname =
        data && data.firstname && data.firstname.substring(0, 1)
          ? data.firstname.substring(0, 1)
          : "A";

      const lastname =
        data && data.lastname && data.lastname.substring(0, 1)
          ? data.lastname.substring(0, 1)
          : "D";

      const initials = `${firstname}.${lastname}`;

      return initials;
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/components/dashboard/navbar.vue